export const USER_COUNTRY_US = "US";
export const MAX_QUANTITY_TO_DISPLAY = 6;
export const availableForBOPISMessage =
  "Available for Buy & Pick-Up at these locations in ";
